export { ReceivablesView } from "../../components/receivables/receivables-view";
